// Establecer un contexto

import { createContext } from "react";

const PlaceContext = createContext(null)

export default PlaceContext